import * as CONFIG from './config';
import axios from 'axios';
import * as jwt from 'jsonwebtoken';

exports.getauditList = function (audittype, objModel) {
    // console.log("audit list==>"+ audittype.audittype);
    return new Promise((resolve, reject) => {

        var postUrl;

        if(audittype.audittype == 'user')
        {
            postUrl ='/audit/useraudit';
        }
        else if(audittype.audittype == 'meeting'){           
            postUrl ='/audit/meetingAudit'; 
        } 
        else if(audittype.audittype == 'agenda'){
            postUrl ='/audit/agendaAudit'; 
        }       
        else if(audittype.audittype == 'folder'){
            postUrl ='/audit/folderAudit'; 
        }       
        else if(audittype.audittype == 'resolutions'){
            postUrl ='/audit/resolutionAudit'; 
        }  
        else if(audittype.audittype == 'decisions'){
            postUrl ='/audit/decisionsAudit'; 
        }  
        else if(audittype.audittype == 'AgendaFile'){
            postUrl ='/audit/AgendaFileAudit'; 
        }  
        else if(audittype.audittype == 'folderFile'){
            postUrl ='/audit/folderFileAudit'; 
        } 
        else if(audittype.audittype == 'resolutionFile'){
            postUrl ='/audit/resolutionFileAudit'; 
        }    

        return CONFIG.httpPost(postUrl, objModel)
        .then(function (response) {
            //  console.log('updateDecision succ==>',postUrl);
            resolve(response);
        })
        .catch(function (err) {
            // console.log('updateDecision err==>',err);
            reject(err);
        });
    });
}




// WEBPACK FOOTER //
// ./api/auditdetails.js